import { Ref, ReactNode } from 'react'
import { InputText, InputTextProps } from 'primereact/inputtext';
import { Controller } from 'react-hook-form';
import 'primereact/inputtext/inputtext.min.css';

import cn from 'classnames';
import classes from './text-field.module.scss';
import { Control } from 'react-hook-form';

export type TextFieldProps = InputTextProps & {
  isRequired?: boolean;
  labelClassName?: string;
  rootClassName?: string;
  inputClassName?: string;
  wrapperInputClassName?: string;
  fieldId: string;
  hint?: string;
  label?: string;
  error?: ReactNode;
  name: string;
  isLoading?: boolean;
  control?: Control<any>;
  innerRef?: Ref<any>
  searchIcon?: boolean;
  type?: string;
};



const TextFieldSimple = (props: TextFieldProps) => (
  <div className={cn(classes.root, props.rootClassName)}>
    <label htmlFor={props.fieldId} className={cn(classes.label, props.labelClassName)}>
      {props.label}
      {props.label && props.isRequired ? <span className={classes.asterix}>*</span> : null}
    </label>
    <div className={cn(props.isLoading && 'p-input-icon-right', classes.wrapperField, props.wrapperInputClassName)}>
      {props.isLoading ? <i className="pi pi-spin pi-spinner" /> : null}
      <InputText
        id={props.fieldId}
        autoComplete={props.autoComplete}
        autoFocus={props.autoFocus}
        disabled={props.disabled}
        placeholder={props.placeholder}
        className={cn(classes.textField, props.inputClassName, { [classes.textFieldError]: props.error })}
        maxLength={props.maxLength}
        keyfilter={props.keyfilter}
        ref={props.innerRef}
        name={props.name}
        value={props.value}
        type={props.type}
        onKeyPress={props.onKeyPress}
        onChange={props.onChange}
        onBlur={props.onBlur}
      />
    </div>
    <small className={props.error ? classes.error : classes.hint}>{props.error}</small>
  </div>
);

TextFieldSimple.defaultProps = {
  autoComplete: 'nope',
}

export const TextField = (props: TextFieldProps) => (
  !props.control
    ? <TextFieldSimple {...props} />
    : <Controller render={({ field: { value = '', ref, ...field } }) => <TextFieldSimple value={value} {...field} {...props}  /> }
        name={props.name}
        control={props.control}
      />
);
